import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { Graph } from '@/utils/function/dijkstra';
interface NavigationState {
  graph: Graph;
  setGraph: (graph: Graph) => void;
}

// Zustand store 생성
const useNavigationStore = create<NavigationState>()(
  subscribeWithSelector((set, _get) => ({
    graph: {},
    setGraph: (graph) => {
      set({ graph });
    },
  }))
);

export default useNavigationStore;
